import { createOrGetFetchedState } from '@vista-digital/utilities';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { browsingDomainStore } from '../../store';
import { assignShowtimeRelatedData } from '../../utils/showtimes/assign-related-data';
/**
 * Loads a showtime by its unique identifier.
 *
 * @param showtimeId The unique identifier of the showtime.
 * @param reloadCachedData Indicates whether the showtime should be reloaded if currently cached.
 * @returns The loaded showtime.
 */
export const loadShowtimeById = async (showtimeId, reloadCachedData = false) => {
    const state = createOrGetFetchedState(browsingDomainStore.data.showtimesById, showtimeId);
    return await loadDataFromApi({
        api: () => ocapiClient.instance.v1.browsing.masterData.showtimes.getById(showtimeId),
        state,
        cacheDuration: getCacheDuration('showtimes'),
        onSuccess,
        reloadCachedData
    });
};
const onSuccess = (response, cacheDuration) => {
    const { showtime, relatedData } = response;
    assignShowtimeRelatedData(relatedData, cacheDuration);
    return showtime;
};
//# sourceMappingURL=load-showtime-by-id.js.map